__turbopack_context__.v({
  "confirmation": "GDPRRequestForm-module__kMrEHq__confirmation",
  "form": "GDPRRequestForm-module__kMrEHq__form",
  "grid": "GDPRRequestForm-module__kMrEHq__grid",
  "honeypot": "GDPRRequestForm-module__kMrEHq__honeypot",
  "page": "GDPRRequestForm-module__kMrEHq__page",
  "status": "GDPRRequestForm-module__kMrEHq__status",
  "statusError": "GDPRRequestForm-module__kMrEHq__statusError",
  "statusSuccess": "GDPRRequestForm-module__kMrEHq__statusSuccess",
  "submit": "GDPRRequestForm-module__kMrEHq__submit",
});
